import SkusEntirePage from '@/components/skus/SkusEntirePage';
import getSkusServerSideProps from '@/lib/serverSideProps/serverSidePropsPages/getSkusServerSideProps';
import { SkusServerProps } from '@/types/props/pages';

export default function SkuPage(props: SkusServerProps) {
  return <SkusEntirePage {...props} />;
}

export const getServerSideProps = getSkusServerSideProps;
